import { FriendApiFriendDeleteRequest } from '../../openapi/api'
import appApiClient from './appApiClient'
import useBaseMutation from './useBaseMutation'

export const useFriendDeleteMutation = () =>
  useBaseMutation({
    mutationFn: (req: FriendApiFriendDeleteRequest, config) =>
      appApiClient.friendApi.friendDelete(req, config),
  })
